import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PendidikanService from "../../services/PendidikanService";
import {message} from "antd";

export const initialState = {
    loading: false,
    dataPendidikan: [],
    dataPendidikanByID:[],
    showMessage:false,
    message:'',
}


export const getDataPendidikan = createAsyncThunk('ref/pendidikan',async (data, { rejectWithValue }) => {
    try {
        const response = await PendidikanService.getDataAll(data)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataPendidikanByID = createAsyncThunk('ref/pendidikanbyid',async (data, { rejectWithValue }) => {
    const {token,id,id_jadwal}=data;
    try {
        const response = await PendidikanService.getDataByID(token,id,id_jadwal)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const pendidikanSlice = createSlice({
    name: 'pendidikan',
    initialState,
    reducers: {
        showDataSuccess: (state, action) => {
            state.loading = false
            state.dataPendidikan = action.payload
        },
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPendidikan.fulfilled, (state, action) => {
                state.loading = false
                state.dataPendidikan = action.payload
            })
            .addCase(getDataPendidikan.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataPendidikan.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataPendidikan = action.payload
            })
            .addCase(getDataPendidikanByID.fulfilled, (state, action) => {
                state.loading = false
                state.dataPendidikanByID = action.payload
            })
            .addCase(getDataPendidikanByID.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataPendidikanByID.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataPendidikanByID = action.payload
            })
    },
})

export const {
    showDataSuccess,
    showLoading
} = pendidikanSlice.actions

export default pendidikanSlice.reducer
